var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8924 27.2574L23.8929 27.2581L23.8979 27.2665L23.8983 27.2672L26.7558 32.0514C29.0837 35.9312 33.2838 38.313 37.8089 38.313C44.6029 38.313 50.1218 32.7941 50.1218 26.0001C50.1218 19.2062 44.6029 13.6873 37.8089 13.6873C34.7592 13.6873 31.9979 14.8159 29.8699 16.6542C28.8441 17.5404 28.7309 19.0904 29.6171 20.1162C30.5032 21.1421 32.0532 21.2553 33.0791 20.3691C34.3647 19.2585 36.0012 18.5964 37.8089 18.5964C41.8916 18.5964 45.2127 21.9174 45.2127 26.0001C45.2127 30.0829 41.8916 33.4039 37.8089 33.4039C35.0118 33.4039 32.4093 31.9302 30.9669 29.5283L30.9669 29.5282L30.9663 29.5273L30.9654 29.5257L30.9648 29.5248L28.1083 24.7422L28.1078 24.7415L28.1036 24.7345L28.1032 24.7338L25.2245 19.9502L25.224 19.9495L25.2229 19.9476C22.8948 16.0685 18.6952 13.6873 14.1706 13.6873C7.37666 13.6873 1.85767 19.2062 1.85767 26.0001C1.85767 32.7941 7.37666 38.313 14.1706 38.313C17.2725 38.313 20.0728 37.1574 22.2087 35.27C23.2245 34.3724 23.3203 32.8212 22.4227 31.8054C21.5251 30.7895 19.9739 30.6937 18.958 31.5914C17.6788 32.7218 16.0221 33.4039 14.1706 33.4039C10.0878 33.4039 6.76676 30.0828 6.76676 26.0001C6.76676 21.9174 10.0878 18.5964 14.1706 18.5964C16.9687 18.5964 19.5721 20.0711 21.0142 22.4746L23.8924 27.2574Z",
    fill: "url(#paint0_linear_48_329)",
    stroke: "url(#paint1_linear_48_329)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_329",
    x1: 25.9897,
    y1: 13.1873,
    x2: 25.9897,
    y2: 38.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFC532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_48_329",
    x1: 25.9897,
    y1: 13.1873,
    x2: 25.9897,
    y2: 38.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.b8f5608d02e1eaacca235afd23ab6633.svg";
export { ForwardRef as ReactComponent };